import DOMPurify from 'dompurify';

const sanitizeHtml = (value) => DOMPurify.sanitize(value, { FORBID_TAGS: ['iframe', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select', 'style'] });

export function questionHtml(value) {
	return sanitizeHtml(String(value ?? ''));
}

export function questionText(value) {
	const element = document.createElement('div');
	element.innerHTML = questionHtml(value).replace(/<br\s*\/?>|<\/(?:p|div|li)>/gi, ' ');
	return element.textContent.replace(/\s+/g, ' ').trim();
}
